import { SubscriptionType, User } from '@griply/types';
import { isBefore } from 'date-fns';

// Subscriptions created before this date predate the current trial model and
// do not count as "had a trial" for premium-banner copy.
const newTrialAllowedDate = new Date('2024-06-10T00:00:00Z');

export const getUserHadTrial = (user: User | null | undefined): boolean =>
  !!user?.subscriptions?.find(
    ({ type, expiresAt, productId }) =>
      (type === SubscriptionType.Trial || !!productId?.includes('custom')) &&
      !!expiresAt &&
      isBefore(newTrialAllowedDate, expiresAt),
  ) || !!user?.user_metadata?.lifetime_trial_expires_date;
